import { MibWeekday } from '../foundations';

export function startOfDay(at: Date): Date {
  return new Date(at.getFullYear(), at.getMonth(), at.getDate());
}

/* Through the calendar fields rather than by milliseconds, so a daylight-saving night stays one day. */
export function addDays(at: Date, days: number): Date {
  return new Date(at.getFullYear(), at.getMonth(), at.getDate() + days);
}

export function isSameDay(a: Date, b: Date): boolean {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

export function startOfWeek(at: Date, weekStartsOn: MibWeekday): Date {
  return addDays(startOfDay(at), -((at.getDay() - weekStartsOn + 7) % 7));
}

export function monthWeeks(date: Date, weekStartsOn: MibWeekday, hiddenDays: readonly number[]): Date[][] {
  const last = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  const weeks: Date[][] = [];
  for (
    let first = startOfWeek(new Date(date.getFullYear(), date.getMonth(), 1), weekStartsOn);
    first <= last;
    first = addDays(first, 7)
  ) {
    weeks.push(Array.from({ length: 7 }, (_, i) => addDays(first, i)).filter((d) => !hiddenDays.includes(d.getDay())));
  }
  return weeks;
}
